<template>
  <transition name="fade">
    <div class="beauty-token-guide" v-if="visible">
      <div class="popup-shadow" @click="hideUidGuidePopup"></div>
      <div class="popup-main">
        <a
          href="javascript:;"
          class="popup-main-close"
          @click="hideUidGuidePopup"
        ></a>
        <div class="popup-main-cont">
          <h1 class="title">PCLoginPassの入手方法は？</h1>
          <p class="text">
            携帯端末のゲームメイン画面で
            <span class="text-blue"> 【ユーザーセンター】 </span>
            <em class="text-ico"></em>
            -【切り替え】-【PCLoginPass】で「LoginPass生成」ボタンをタップすると獲得できます。
          </p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'BeautyTokenGuidePopup',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    hideUidGuidePopup() {
      this.$emit('update:visible', false);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialWebStore/officialWebStore.scss';
.beauty-token-guide {
  z-index: 20;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  .popup {
    &-shadow {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba($color: #000000, $alpha: 0.4);
      transform: scale3d(1, 1, 1) translateZ(0) !important;
      transition: 0 !important;
    }
    &-main {
      box-sizing: border-box;
      overflow: hidden;
      position: absolute;
      top: 50%;
      left: 50%;
      padding-top: 80px;
      transform: translate(-50%, -50%);
      border-radius: 10px;
      background: #fff;
      width: 545px !important;
      height: 484px !important;

      &-close {
        position: absolute;
        right: 32px;
        top: 27px;
        background: url($tmslgImg + 'close.png') no-repeat;
        width: 28px;
        height: 28px;
        cursor: pointer;
      }

      &-cont {
        color: #64563c;
        .title {
          margin-top: 0;
          margin-bottom: 36px;
          font-size: 34px;
          font-weight: bold;
          color: #64563c;
        }
        .text {
          position: relative;
          margin-top: 140px;
          padding: 0 38px;
          font-size: 22px;
          line-height: 28px;
          &-blue {
            color: #0596ff;
          }
          &-ico {
            position: absolute;
            top: -100px;
            right: 22px;
            background: url($beautyImg + 'support-ico.png') no-repeat;
            width: 91px;
            height: 95px;
          }
        }
      }
    }
  }
}
</style>
